import { SharedFeatureLoadingModule } from '@shared/feature/loading';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadImageComponent } from './components/upload-image/upload-image.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { UploadPictureModalComponent } from './components/upload-picture-modal/upload-picture-modal.component';
import { SharedUiModalModule } from '@shared/ui/modal';
import { SharedFeatureDropFileModule } from '@shared/feature/drop-file';
import { ImageCropperModule } from 'ngx-image-cropper';
import { SharedUtilsDisableImageCachingModule } from '@shared/utils/disable-image-caching';
import { SharedUiCardsModule } from '@shared/ui/cards';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';

@NgModule({
  imports: [
    CommonModule,
    SharedUiButtonsModule,
    SharedUtilsDisableImageCachingModule,
    SharedFeatureLoadingModule,
    SharedUiModalModule,
    SharedFeatureDropFileModule,
    ImageCropperModule,
    SharedUiCardsModule,
    SharedFeatureTranslateModule,
  ],
  declarations: [UploadImageComponent, UploadPictureModalComponent],
  exports: [UploadImageComponent],
})
export class SharedFeatureUploadFileModule {}
